import { Component, Inject, OnInit } from '@angular/core';
import { Sensorstation } from 'sensorstation-lib-js';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Group } from 'lcmm-lib-js';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SensorstationService } from '../service/sensorstation.service';

@Component({
  selector: 'app-sensorstation-dialog',
  templateUrl: './sensorstation-dialog.component.html',
  styleUrls: ['./sensorstation-dialog.component.scss'],
  standalone: false,
})
export class SensorstationDialogComponent implements OnInit {
  public form: UntypedFormGroup;

  public sensorstation: Sensorstation;

  public isSensorstationUpdated = false;

  public groups: Group[];

  public loading = false;

  public allowEditing: boolean;

  constructor(
    public dialogRef: MatDialogRef<SensorstationDialogComponent>,
    private sensorstationService: SensorstationService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      sensorstation: Sensorstation;
      groups: Group[];
      allowEditing: boolean;
    }
  ) {
    // eslint-disable-next-line no-param-reassign
    dialogRef.disableClose = false;
    this.sensorstation = data.sensorstation || null;
    this.groups = data.groups || [];
    this.allowEditing = data.allowEditing;
  }

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      sensorstationForm: new UntypedFormGroup({
        deviceId: new UntypedFormControl(this.sensorstation?.deviceId),
        aFESerialNumber: new UntypedFormControl(
          this.sensorstation?.aFESerialNumber
        ),
        name: new UntypedFormControl(this.sensorstation?.name),
        group: new UntypedFormControl(this.sensorstation?.group),
        owner: new UntypedFormControl(this.sensorstation?.owner),
        locationId: new UntypedFormControl(this.sensorstation?.locationId),
        locationForm: new UntypedFormGroup({
          locationId: new UntypedFormControl(
            this.sensorstation?.location?.locationId
          ),
          name: new UntypedFormControl(this.sensorstation?.location?.name),
          country: new UntypedFormControl(
            this.sensorstation?.location?.country
          ),
          street: new UntypedFormControl(this.sensorstation?.location?.street),
          houseNumber: new UntypedFormControl(
            this.sensorstation?.location?.houseNumber
          ),
          city: new UntypedFormControl(this.sensorstation?.location?.city),
          postalCode: new UntypedFormControl(
            this.sensorstation?.location?.postalCode
          ),
          state: new UntypedFormControl(this.sensorstation?.location?.state),
          latitude: new UntypedFormControl(
            this.sensorstation?.location?.latitude
          ),
          longitude: new UntypedFormControl(
            this.sensorstation?.location?.longitude
          ),
        }),
      }),
    });
  }

  private _getSensorstation(): Sensorstation {
    const formValues = this.form.getRawValue().sensorstationForm;
    const locationValues = formValues.locationForm;

    const sensorstation: Sensorstation = {
      ...this.sensorstation,
      deviceId: formValues.deviceId,
      aFESerialNumber: formValues.aFESerialNumber,
      name: formValues.name,
      group: formValues.group,
      owner: formValues.owner,
      locationId: formValues.locationId,
      location: {
        ...this.sensorstation?.location,
        locationId: locationValues.locationId,
        name: locationValues.name,
        country: locationValues.country,
        street: locationValues.street,
        houseNumber: locationValues.houseNumber,
        city: locationValues.city,
        postalCode: locationValues.postalCode,
        state: locationValues.state,
        latitude: locationValues.latitude,
        longitude: locationValues.longitude,
      },
    };

    if (sensorstation.locationId) {
      sensorstation.location.locationId = sensorstation.locationId;
    }

    return sensorstation;
  }

  public onSubmit(): void {
    if (this.form.pristine) {
      this.dialogRef.close(false);
      return;
    }
    this.loading = true;
    this.sensorstationService
      .updateSensorstation(this._getSensorstation())
      .subscribe(
        () => {
          this.isSensorstationUpdated = true;
          this.loading = false;
          this.dialogRef.close(true);
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (err) => {
          this.loading = false;
        }
      );
  }

  public onClose(): void {
    this.dialogRef.close(this.isSensorstationUpdated);
  }
}
